import { useUsersQuery } from "@/common/api/services/users";
import { DataCard } from "@/components/shared/DataCard";
import { useQuery } from "@tanstack/react-query";
import { Users } from "lucide-react";
import { useTranslation } from "react-i18next";

export const UsersStats = () => {
    const { t } = useTranslation();
    const usersQuery = useUsersQuery();

    const { data: stats, isLoading: isStatsLoading, error: statsError } = useQuery(
        usersQuery.userStatisticsQuery
    );

    if (isStatsLoading) {
        return (
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
                {Array.from({ length: 4 }).map((_, index) => (
                    <div
                        key={index}
                        className="h-24 rounded-lg border border-border bg-card text-card-foreground shadow-sm animate-pulse"
                    />
                ))}
            </div>
        );
    }

    return (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
            <DataCard title={t("users.stats.total")} icon={<Users />}>
                <div className="text-2xl font-bold">{stats?.totalUsers || 0}</div>
            </DataCard>
            <DataCard title={t("users.stats.active")} icon={<Users />}>
                <div className="text-2xl font-bold text-green-600">
                    {stats?.activeUsers || 0}
                </div>
            </DataCard>
            <DataCard title={t("users.stats.pending")} icon={<Users />}>
                <div className="text-2xl font-bold text-yellow-600">
                    {stats?.pendingUsers || 0}
                </div>
            </DataCard>
            <DataCard title={t("users.stats.inactive")} icon={<Users />}>
                <div className="text-2xl font-bold text-red-600">
                    {stats?.inactiveUsers || 0}
                </div>
            </DataCard>
        </div>
    );
}; 